import { graphql } from 'gatsby';

export { default } from './PeopleList';

export const peopleQuery = graphql`
  query PeopleListQuery($id: String) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        sections {
          title
          text_md
          showPhotos
          showShadows
          people {
            html
            frontmatter {
              name
              pronouns
              role
              photo {
                id
                childImageSharp {
                  fixed(width: 95, height: 95) {
                    ...GatsbyImageSharpFixed_noBase64
                  }
                }
              }
            }
            fields {
              slug
            }
          }
        }
      }
    }
  }
`;
